// ---------------------------
// AUTO-GENERATED. DO NOT EAT.
// ---------------------------
import { createEnum } from "@cartographerio/util";
const NeverDries = "NeverDries";
const DriesRarely = "DriesRarely";
const DriesMostyears = "DriesMostyears";
const DriesAnnually = "DriesAnnually";
const None = "None";
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const UclPitStopHistoricalKnowledgeEnum = {
    ...createEnum("UclPitStopHistoricalKnowledge", [
        [NeverDries, "Never dries"],
        [DriesRarely, "Dries no more than two years in ten or only in drought"],
        [DriesMostyears, "Dries between three years in ten to most years"],
        [DriesAnnually, "Dries annually"],
        [None, "No previous knowledge ascertained"],
    ]),
    NeverDries,
    DriesRarely,
    DriesMostyears,
    DriesAnnually,
    None,
};
null;
null;
export default UclPitStopHistoricalKnowledgeEnum;
//# sourceMappingURL=UclPitStopHistoricalKnowledgeEnum.generated.js.map